// extracted by mini-css-extract-plugin
export default {"absolute-container":"Puzzle_absolute-container__aTCkY","container":"Puzzle_container__vSfr9"};